import { __extends } from "tslib";
import { Event } from './Event';
var GeolocationEvent = /** @class */ (function (_super) {
    __extends(GeolocationEvent, _super);
    function GeolocationEvent(type, bubbles, cancelable, latitude, longitude, altitude, hAccuracy, vAccuracy, speed, heading, timestamp) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (latitude === void 0) { latitude = 0; }
        if (longitude === void 0) { longitude = 0; }
        if (altitude === void 0) { altitude = 0; }
        if (hAccuracy === void 0) { hAccuracy = 0; }
        if (vAccuracy === void 0) { vAccuracy = 0; }
        if (speed === void 0) { speed = 0; }
        if (heading === void 0) { heading = 0; }
        if (timestamp === void 0) { timestamp = 0; }
        return _super.call(this, type, bubbles, cancelable) || this;
    }
    GeolocationEvent.classInitializer = null;
    GeolocationEvent.classSymbols = null;
    GeolocationEvent.instanceSymbols = null;
    // JS -> AS Bindings
    GeolocationEvent.UPDATE = 'update';
    return GeolocationEvent;
}(Event));
export { GeolocationEvent };
